import { Grid } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { ProductOverview } from './ProductOverview/ProductOverview';

const maxGallerySize = '42rem';
export const DividerGrid = styled.div`
    display: grid;
    grid-template-columns: 100%;

    ${purpurMedia('lg')`
        grid-template-columns: minmax(min(57.75%, ${maxGallerySize}), ${maxGallerySize}) 41.25%;
        justify-content: space-between;
        column-gap: ${getPurpurSpacing('300')};
    `}
`;

export const PageGrid = styled(Grid)`
    display: block;
    padding-top: 1.563rem;
    padding-bottom: ${getPurpurSpacing('250')};
`;

export const Title = styled.h1`
    font-size: 1.75rem;
    margin-top: 0;

    ${purpurMedia('lg')`
        font-size: 2rem;
    `};
`;

export const DescriptionSection = styled(ProductOverview)`
    margin-top: 4.5rem;
`;
